import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPostAdminBuildings_buildingIdHeatingSync = z.any()
export type TagsPostAdminBuildings_buildingIdHeatingSync = z.infer<typeof tagsPostAdminBuildings_buildingIdHeatingSync>

export const paramsPostAdminBuildings_buildingIdHeatingSync = z.object({ "buildingId": z.string().uuid() })
export type ParamsPostAdminBuildings_buildingIdHeatingSync = z.infer<typeof paramsPostAdminBuildings_buildingIdHeatingSync>

export const bodyPostAdminBuildings_buildingIdHeatingSync = z.object({ "year": z.number().gte(1775).lte(9999) }).strict()
export type BodyPostAdminBuildings_buildingIdHeatingSync = z.infer<typeof bodyPostAdminBuildings_buildingIdHeatingSync>

export const responsePostAdminBuildings_buildingIdHeatingSync = z.object({ "payload": z.object({ "started": z.boolean() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponsePostAdminBuildings_buildingIdHeatingSync = z.infer<typeof responsePostAdminBuildings_buildingIdHeatingSync>

interface IPostAdminBuildings_buildingIdHeatingSync extends BaseMethodType {
  tags: TagsPostAdminBuildings_buildingIdHeatingSync,
  params: ParamsPostAdminBuildings_buildingIdHeatingSync,
  body: BodyPostAdminBuildings_buildingIdHeatingSync,
  response: ResponsePostAdminBuildings_buildingIdHeatingSync
}
export const URL = '/admin/buildings/:buildingId/heating/sync'
export const validation = {
  post: {
    tags: tagsPostAdminBuildings_buildingIdHeatingSync,
    params: paramsPostAdminBuildings_buildingIdHeatingSync,
    body: bodyPostAdminBuildings_buildingIdHeatingSync,
    response: responsePostAdminBuildings_buildingIdHeatingSync
  }
}
export interface AdminBuildings_buildingIdHeatingSync extends BaseRouteType {
  post: IPostAdminBuildings_buildingIdHeatingSync
}